import CrudNotification from './CrudNotification'
import { notificationTypes } from './utils/legacy/native-notification-types'
import { formNotificationSwitch } from './utils/form-notification-switch'

export { notificationTypes, formNotificationSwitch }
export default CrudNotification
